const months = [
	['январь', 'января'],
	['февраль', 'февраля'],
	['март', 'марта'],
	['апрель', 'апреля'],
	['май', 'мая'],
	['июнь', 'июня'],
	['июль', 'июля'],
	['август', 'августа'],
	['сентябрь', 'сентября'],
	['октябрь', 'октября'],
	['ноябрь', 'ноября'],
	['декабрь', 'декабря'],
];

export const days = [
	['Воскресенье', 'ВС'],
	['Понедельник', 'ПН'],
	['Вторник', 'ВТ'],
	['Среда', 'СР'],
	['Четверг', 'ЧТ'],
	['Пятница', 'ПТ'],
	['Суббота', 'СБ']
];

export function dateToYYYYMMDD(date = null) {
	if (!date) return '';

	return date.getFullYear() + '-' + (date.getMonth() < 9 ? '0' : '') + (date.getMonth() + 1) + '-' + (date.getDate() < 10 ? '0' : '') + date.getDate();
}

export function dateToDDMMYYYY(date = null) {
	if (!date) return '';

	return (date.getDate() < 10 ? '0' : '') + date.getDate() + '.' + (date.getMonth() < 9 ? '0' : '') + (date.getMonth() + 1) + '.' + date.getFullYear();
}

export function dateFromDDMMYYYY(date = null) {
	if (!date) return;

	const arDate = date.split('.');
	return new Date(arDate[2], arDate[1] - 1, arDate[0]);
}

export function dateFromDDMMYYYYtoYYYYMMDD(date = null) {
	if (!date) return;

	const arDate = date.split('.');
	return arDate[2] + '-' + arDate[1] + '-' + arDate[0];
}

export function getWeekPeriodByDate(date = null) {
	if (!date) return;

	const startDay = 1;
	const day = date.getDay();
	const weekStart = new Date(date.valueOf() - (day <= 0 ? (7 - startDay) : (day - startDay)) * 86400000);
	const weekEnd = new Date(weekStart.valueOf() + 6 * 86400000);

	return [weekStart, weekEnd]
}

export function getWeekPeriodString(period = null) {
	if (!period) return '';

	const firstDay = period[0];
	const lastDay = period[1];
	const sameMonth = firstDay.getMonth() === lastDay.getMonth();

	return firstDay.getDate() + (sameMonth ? '' : ' ' + getMonthByDate(firstDay, true)) + '—' + lastDay.getDate() + ' ' + getMonthByDate(lastDay, true);
}


export function getWeekdayByDate(date = null, short = false) {
	if (!date) return;

	return short ? days[date.getDay()][1] : days[date.getDay()][0];
}

export function getMonthByDate(date = null, secondForm = false) {
	if (!date) return;

	return secondForm ? months[date.getMonth()][1] : months[date.getMonth()][0];
}

export function timeToMinutes(time) {
	const [hours, minutes] = time.split(':').map(Number);
	return hours * 60 + minutes;
};

export function currentTime(timestamp = null) {
    let date;
    
    if (timestamp != null) {
        date = new Date();
        date.setHours(0, 0, 0, 0);
        date.setSeconds(timestamp);
    } else {
        date = new Date();
    }
    
    const h = date.getHours();
    const m = addZero(date.getMinutes());
    return h + ':' + m;
}

const addZero = (param) => {
	return param < 10 ? '0' + param : param;
}

export const getNotificationDateString = (timestamp) => {
	const dateNow = new Date();
	const date = new Date(timestamp);

	const oneDay = 86400000;
	const hours = addZero(date.getHours());
	const minutes = addZero(date.getMinutes());
	const day = addZero(date.getDate());
	let res = `, ${hours}:${minutes}`;

	if (dateNow.getFullYear() !== date.getFullYear()) {
		res = `${date.getDate()} ${months[date.getMonth()][1]} ${date.getFullYear()}${res}`;
	} else if (Math.abs(date.getDate() - dateNow.getDate()) >= 2) {
		res = `${day} ${months[date.getMonth()][1]}${res}`;
	} else if (Math.abs(date.getDate() - dateNow.getDate()) === 1 && dateNow - date <= 2 * oneDay) {
		res = `Вчера${res}`;
	} else if (Math.abs(date.getDate() - dateNow.getDate()) === 0) {
		if (Math.floor((dateNow - date) / 1000 / 60) < 60) {
			res = `${Math.floor((dateNow - date) / 1000 / 60)} мин назад`;
		} else {
			res = `Сегодня${res}`;
		}
	} else if (Math.abs(date.getDate() - dateNow.getDate()) < 2 && dateNow.getMonth() !== date.getMonth()) {
		res = `${day} ${months[date.getMonth()][1]}${res}`;
	}

	return res;
}


export function getNearbyMonths(date = null) {
	const result = [];
	const inputDate = date ? new Date(date) : new Date();

	const baseDate = new Date(inputDate.getFullYear(), inputDate.getMonth(), 1);
	
	for (let i = -6; i <= 6; i++) {
		const year = baseDate.getFullYear();
		const month = baseDate.getMonth() + i;
		
		const calculatedYear = year + Math.floor(month / 12);
		const calculatedMonth = ((month % 12) + 12) % 12;
		
		const monthName = months[calculatedMonth][0].charAt(0).toUpperCase() + 
						 months[calculatedMonth][0].slice(1);

		result.push(`${monthName} ${calculatedYear}`);
	}

	console.log(result);
	return result;
}

export function secondsToTime(secondsStr) {
	const totalSeconds = parseInt(secondsStr, 10);
	const hours = Math.floor(totalSeconds / 3600);
	const minutes = Math.floor((totalSeconds % 3600) / 60);
	return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
}

export function getWorkTime(startStr, endStr) {
	const start = parseInt(startStr, 10);
	const end = parseInt(endStr, 10);

	const diffMs = end - start;
	const hours = Math.floor(diffMs / 3600);
	const minutes = Math.floor((diffMs % 3600) / 60);

	const hoursSum = minutes === 30 ? `${hours + minutes / 60} ч.` : `${hours} ч.`;

	const endTimeHours = Math.floor(end / 3600);
	const endTimeMinutes = Math.floor((end % 3600) / 60);
	const time = `${String(endTimeHours).padStart(2, '0')}:${String(endTimeMinutes).padStart(2, '0')}`;

	return {
		hoursSum,
		time
	};
}

export function convertDateFormat(date_string) {
	let [day, month, year] = date_string.split('.');
	let date = new Date(year, month - 1, day);
	return parseInt(day) + ' ' + months[month - 1][1] + ', ' + days[date.getDay()][1];
}

export function timeToSeconds(timeString) {
	if (!timeString) return 0;
	const [hours, minutes] = timeString.split(':').map(Number);
	return hours * 3600 + minutes * 60;
};

export function parseDateToTimestamp(dateString) {
	const [day, month, year] = dateString.split('.');
	const date = new Date(year, month - 1, day);
	return Math.floor(date.getTime() / 1000);
}

export function getHours(seconds) {
	return seconds / 3600;
};

export function getDaysOfMonth(nextMonth) {
	let now = new Date();
	if (nextMonth) {
        now = new Date(now.getFullYear(), now.getMonth() + 1, 1);
    }
	const year = now.getFullYear();
	const month = now.getMonth();
	const daysInMonth = new Date(year, month + 1, 0).getDate();

	const days = [];
	for (let i = 1; i <= daysInMonth; i++) {
		const date = new Date(year, month, i);
		const dayOfWeek = getWeekdayByDate(date, true);
		const monthName = getMonthByDate(date, true);
		const dateFormat = `${padZero(i)}.${padZero(month + 1)}.${year}`;
		const isToday = isDateToday(date);
		days.push({
			date_format: dateFormat,
			day: i,
			month: monthName,
			day_of_week: dayOfWeek,
			is_today: isToday
		});
	}

	return days;
}

function padZero(num) {
	return (num < 10 ? '0' : '') + num;
}

function isDateToday(date) {
	const now = new Date();
	return date.getDate() === now.getDate() &&
		date.getMonth() === now.getMonth() &&
		date.getFullYear() === now.getFullYear();
}